module.exports = __webpack_public_path__ + "img/Flag_of_Austria.0d38e4d8.svg";